// Sélecteur rapide de dossier — stockage localStorage (épinglés + récents).
// Fonctions pures de manipulation testées dans quickAccessStore.test.ts.

export const MAX_RECENTS = 8;

export function addPin(pinned: string[], id: string): string[] {
  if (pinned.includes(id)) return pinned;
  return [...pinned, id];
}

export function removePin(pinned: string[], id: string): string[] {
  return pinned.filter((p) => p !== id);
}

export function pushRecent(recents: string[], id: string): string[] {
  return [id, ...recents.filter((r) => r !== id)].slice(0, MAX_RECENTS);
}

/** Dossiers encore connus, dans l’ordre des derniers ouverts. */
export function resolveRecentDossiers<T extends { id: string }>(
  recentIds: string[],
  dossiers: T[],
): T[] {
  const byId = new Map(dossiers.map((d) => [d.id, d]));
  return recentIds
    .map((id) => byId.get(id))
    .filter((d): d is T => d != null);
}

export const PINNED_KEY = 'cime.dossier.pinned';
export const RECENTS_KEY = 'cime.dossier.recents';

/** Parse une valeur localStorage en string[]. Tolère null/JSON invalide. */
export function parseIds(raw: string | null): string[] {
  if (raw == null) return [];
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x): x is string => typeof x === 'string');
  } catch {
    return [];
  }
}

/** Lit une liste d'ids depuis localStorage (SSR/indispo-safe). */
export function readIds(key: string): string[] {
  if (typeof window === 'undefined' || !window.localStorage) return [];
  return parseIds(window.localStorage.getItem(key));
}

/** Écrit une liste d'ids dans localStorage (no-op si indispo). */
export function writeIds(key: string, ids: string[]): void {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(key, JSON.stringify(ids));
  } catch {
    // quota / mode privé : on ignore silencieusement
  }
}
